import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingScreen } from '../lib/LoadingScreen';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const navigate = useNavigate();
  const { t } = useTranslation()
  useEffect(() => {
    navigate('/dashboard')
  }, [])
  return <LoadingScreen message={t("core:authGuard.isLoading.message")} />
}
export default Home;